import { generateLocalizedRouteConfig, LocalizedRoutes } from '@/router/localizedRouting';
import { DETAILS_PAGE_PATH } from '@/router/routes/constants';
import { Pages } from '@/types';
import { RouteRecordRaw } from 'vue-router';

const routes: LocalizedRoutes = {
  de: { path: DETAILS_PAGE_PATH.de, meta: { requiresAuth: true, scrollToTop: true } },
  en: { path: DETAILS_PAGE_PATH.en, meta: { requiresAuth: true, scrollToTop: true } },
  fr: { path: DETAILS_PAGE_PATH.fr, meta: { requiresAuth: true, scrollToTop: true } },
  it: { path: DETAILS_PAGE_PATH.it, meta: { requiresAuth: true, scrollToTop: true } },
};

const Component = () => import('@/pages/PropertyDetailsPage/PropertyDetailsPage.vue');

const localizedRouteConfig = (): RouteRecordRaw[] =>
  generateLocalizedRouteConfig(routes, Component, Pages.PDP);

export default localizedRouteConfig;
